/* Ian - 2026-06-24 - Stockist locator hydration.
   The section server-renders a static baseline (crawlable, works with no JS) plus a paginated
   JSON payload of the `stockist` metaobject (250 per page, Shopify's loop limit). This script
   reads page 1 inline, then pulls the remaining pages by re-fetching the page with `?page=N`
   (the Section Rendering API ignores the page param, a full-page fetch does not), de-dupes by
   metaobject handle, and rebuilds the continent/country accordion + side-nav from the live data.
   If there are no entries or anything fails, the static baseline is left untouched. */
(function () {
  var PREF = ['Europe', 'North America', 'Oceania', 'Asia', 'South America'];

  function esc(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function handleize(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function parseJSON(text) {
    try { return JSON.parse(text || '[]'); } catch (e) { return null; }
  }

  function keyOf(e) {
    return e.id || (String(e.name || '') + '|' + String(e.map_link || '') + '|' + String(e.town || ''));
  }

  // Re-fetch the whole page with ?page=N (preserving preview/session params) and pull this
  // section's JSON payload back out. A full-page request honours paginate; SRA does not.
  function fetchPage(sid, n) {
    var u = new URL(location.href);
    u.searchParams.set('page', n);
    return fetch(u.toString(), { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('sl-data-' + sid);
        return el ? (parseJSON(el.textContent) || []) : [];
      })
      .catch(function () { return []; });
  }

  function render(root, entries) {
    var vis = entries.filter(function (e) { return e.visible !== false; });
    if (!vis.length) return;

    var conts = {};
    vis.forEach(function (e) {
      var c = e.continent || 'Other';
      (conts[c] = conts[c] || []).push(e);
    });

    var order = [];
    PREF.forEach(function (c) { if (conts[c]) order.push(c); });
    Object.keys(conts).sort().forEach(function (c) { if (PREF.indexOf(c) < 0) order.push(c); });

    var navHtml = '';
    var mainHtml = '';

    order.forEach(function (cont) {
      var list = conts[cont];
      var cid = 'sl-' + handleize(cont);
      navHtml += '<li><a href="#' + cid + '" data-cont="' + cid + '">' + esc(cont) +
        '<span class="sl-navcount">' + list.length + '</span></a></li>';

      var countries = {};
      list.forEach(function (e) {
        var k = e.country || '';
        (countries[k] = countries[k] || []).push(e);
      });
      var cnames = Object.keys(countries).sort(function (a, b) { return a.localeCompare(b); });

      var sec = '<section id="' + cid + '" class="sl-continent"><div class="sl-conthead"><h2>' +
        esc(cont) + '</h2><span class="sl-contsub">' + list.length + ' stockist' +
        (list.length === 1 ? '' : 's') + '</span></div>';

      cnames.forEach(function (cn) {
        var stores = countries[cn].slice().sort(function (a, b) {
          var ta = a.town || '', tb = b.town || '';
          if (ta !== tb) return ta.localeCompare(tb);
          return (a.name || '').localeCompare(b.name || '');
        });
        sec += '<details class="sl-country"><summary><span class="sl-cname">' + esc(cn) +
          '</span><span class="sl-cmeta"><span class="sl-ccount">' + stores.length +
          '</span><span class="sl-chev"></span></span></summary><div class="sl-stores">';
        stores.forEach(function (s) {
          var town = (s.town && String(s.town).trim()) ? esc(s.town) : '&nbsp;';
          var links = '';
          if (s.website) links += '<a class="sl-lk" href="' + esc(s.website) +
            '" target="_blank" rel="nofollow noopener">Website</a>';
          if (s.map_link) links += '<a class="sl-lk" href="' + esc(s.map_link) +
            '" target="_blank" rel="nofollow noopener">View on map</a>';
          sec += '<div class="sl-store"><div class="sl-info"><div class="sl-town">' + town +
            '</div><div class="sl-name">' + esc(s.name) + '</div></div><div class="sl-links">' +
            links + '</div></div>';
        });
        sec += '</div></details>';
      });

      sec += '</section>';
      mainHtml += sec;
    });

    var navUl = root.querySelector('.sl-nav');
    if (navUl) navUl.innerHTML = navHtml;
    var main = root.querySelector('main');
    if (main) main.innerHTML = mainHtml;
  }

  function spy(root) {
    function onScroll() {
      var links = [].slice.call(root.querySelectorAll('.sl-side a'));
      var idx = 0;
      links.forEach(function (a, i) {
        var s = document.getElementById(a.getAttribute('data-cont'));
        if (s && s.getBoundingClientRect().top <= 140) idx = i;
      });
      links.forEach(function (a) { a.classList.remove('is-active'); });
      if (links[idx]) links[idx].classList.add('is-active');
    }
    if (!root._spyBound) {
      document.addEventListener('scroll', onScroll);
      root._spyBound = true;
    }
    onScroll();

    var nav = root.querySelector('.sl-side nav');
    if (nav && !nav._clickBound) {
      nav._clickBound = true;
      nav.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('a[data-cont]') : null;
        if (!a) return;
        e.preventDefault();
        var t = document.getElementById(a.getAttribute('data-cont'));
        if (t) t.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  function init(root) {
    spy(root); // delegated handlers survive the rebuild; safe to bind on the baseline
    var sid = root.getAttribute('data-section-id');
    var dataEl = document.getElementById('sl-data-' + sid);
    if (!dataEl) return;
    var first = parseJSON(dataEl.textContent);
    if (!first || !first.length) return; // no metaobjects -> keep static baseline

    var count = parseInt(dataEl.getAttribute('data-count'), 10) || first.length;
    var perPage = first.length || 250;
    var pages = Math.max(1, Math.ceil(count / perPage));

    var seen = {};
    var all = [];
    function add(arr) {
      arr.forEach(function (e) {
        var k = keyOf(e);
        if (!seen[k]) { seen[k] = 1; all.push(e); }
      });
    }
    add(first);

    // Only swap in the live list once we've assembled the FULL count. If pagination can't
    // reach the rest, leave the complete static baseline in place (never show a partial list).
    function finish() {
      if (all.length >= count) { render(root, all); spy(root); }
    }

    if (pages <= 1) { finish(); return; }

    var n = 2;
    var cap = Math.min(pages, 40);
    function next() {
      if (n > cap) { finish(); return; }
      var page = n++;
      fetchPage(sid, page).then(function (arr) {
        add(arr);
        next();
      });
    }
    next();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('.sl-wrap[data-section-id]')).forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
